import { SlideOverContentWrapper, SlideOverFooter, SlideOverWrapper } from '@/components/slideOvers_v2';
import { PlusIcon } from '@heroicons/react/outline';
import { FunctionComponent, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { FileUploadingFooterV2 } from '.';
import { DataSourceTypePanelContentV2, DataSourceTypePanelHeaderV2 } from '..';
import { DataSourceIDEnum, DataSourceType, EDataSourceCategory } from '../../../../models/dataSource';
import { EStatus } from '../../../../models/fileUpload';
import { ISlideOverContentProps } from '../../../../models/slideOver';
import { RootState } from '../../../../reducers';

interface IDataSourceTypePanelProps {
  dataSourceType: DataSourceType;
  onAddDataSourceClicked: (source: DataSourceType) => void;
}

const DataSourceTypePanelV2: FunctionComponent<PropsWithChildren<IDataSourceTypePanelProps & ISlideOverContentProps>> = ({
  dataSourceType,
  closeSlideOver,
  onAddDataSourceClicked,
}) => {
  const { t } = useTranslation('data_sources');

  const id = dataSourceType.id as DataSourceIDEnum;
  const fileUploadStatus = useSelector((state: RootState) => state.fileUploading.status);

  return (
    <SlideOverWrapper>
      <DataSourceTypePanelHeaderV2 id={id} title={t(`catalog.${id}.title`)} />

      <SlideOverContentWrapper className='!mt-0'>
        <DataSourceTypePanelContentV2 dataSourceType={dataSourceType} />
      </SlideOverContentWrapper>

      {fileUploadStatus?.uploadingStatus === EStatus.UPLOADING && dataSourceType.category === EDataSourceCategory.FILE ? (
        <FileUploadingFooterV2 />
      ) : (
        <SlideOverFooter
          closeSlideOver={closeSlideOver}
          confirmLabel={t('slideover.footer.add_this_data_source')}
          showCancelButton={false}
          onConfirmClicked={() => onAddDataSourceClicked(dataSourceType)}
          confirmIconRight={<PlusIcon />}
        />
      )}
    </SlideOverWrapper>
  );
};

export default DataSourceTypePanelV2;
